
export default {
  name: 'PagesAboutExtentionsServicesManagement',
  data() {
    return {
      selectedServices: [],
    }
  },
  computed: {
    modules() {
      return this.$store.getters['settings/getModules']
    },
    services() {
      const services = this.$store.getters['settings/getServices']
      return services
    },
  },
  watch: {
    selectedServices() {
      this.$emit('update', this.selectedServices)
    },
  },
  mounted() {
    for (const service of this.services) {
      if (service.blockCheck) {
        this.selectedServices.push(service._id)
      }
    }
  },
  methods: {
    moduleServices(id) {
      return this.services.filter((service) => service.module === id)
    },
  },
}
